module.exports = __webpack_public_path__ + "img/2.b0f7c58b.jpg";